import React from 'react';
import DesktopSimpleSearchScreen from "./DesktopSimpleSearchScreen.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default function MobileSimpleSearchScreen(props) {
  return /*#__PURE__*/_jsx(DesktopSimpleSearchScreen, {
    ...props,
    areaVariant: "mobileSimpleSearchArea|simpleSearchArea",
    contentLayout: "flex:mobileSimpleSearchContent|simpleSearchContent|colL",
    contentVariant: "mobileSimpleSearchContent|simpleSearchContent",
    captionVariant: "mobileSimpleSearchCaption|simpleSearchCaption|caption"
  });
}